import { render, staticRenderFns } from "./PriceContributionInput.vue?vue&type=template&id=28915991&"
import script from "./PriceContributionInput.vue?vue&type=script&lang=js&"
export * from "./PriceContributionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports